var _path, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37256 4C1.37256 2.067 2.93956 0.5 4.87256 0.5H26.2355C28.1685 0.5 29.7355 2.067 29.7355 4V18.9684C29.7355 20.9014 28.1685 22.4684 26.2355 22.4684H4.87256C2.93956 22.4684 1.37256 20.9014 1.37256 18.9684V4Z",
    fill: "url(#paint0_linear_1_27)",
    stroke: "#CED0DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.14972,
    y: 2.15363,
    width: 18.9298,
    height: 19.3796,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_27",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.14972,
    y: 2.15363,
    width: 18.9298,
    height: 19.3796,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.14972,
    y: 2.15363,
    width: 18.9298,
    height: 19.3796,
    fill: "#CCCFD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_27",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_27",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_27",
    x1: 30.2355,
    y1: 22.9684,
    x2: 30.2355,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_27",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAAmRJREFUeAHt2zFKxEAUBuCorYKt4inEwtLLeI+5xV7H1ht4Da0FfQMJhBB2R7cImfctDOvqhmS+/88kRRwGLwIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgsInAbez1dZM92+nmAjX89xg/MUoMr0QC8/BrAZQgefhKkKQAa2f+FP70XpJYpJtmS/hK0Gkt/hK+EnRWguuYz3S3P4Xb+l46szhrOldnbb3dxt+x68cYT/84hJfY5iLGWwyvHQtcxrEfYrSe+cvvlR3P3aGPAkqgCoMSKIES6MCgBEqgBDoQAu4J1EAJdMBKoAMuBzpQBdwT6IES6ICVQAdcDnSgCrgn0AMl0AErgQ64HOhAFXBPoAdKoANWAh1wOdCBKuCeQA+G+zD4irF8lLzl82ds98BwvwJ3cegfMVrCXn6nhv+836k7cuEn7oDwhW/Zz9gBZ37G1Mc5C1/4lv2MHXDmZ0zdsp84deEL37KfuAPCF767/YwdcOZnTH2cs/CFb9nP2AFnfsbULfuJUxe+8C37iTsgfOG728/YAWd+xtTHOd/Eu0e3ExegTr3EWD6Xf+qz5/arXEevEnM5Ffr0d+F3FPx8Ki0lEP5crMOfj5VA+B0GvjaltRIIf02q49/NSyD8joM+NrVaAuEfE0rwN/+fnyBkUyRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAlkEfgGUJ0UJGDY99gAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/right-button.bdb1468c550e04d9639cdb0a87f493eb.svg";
export { ForwardRef as ReactComponent };